export type Recordkeeping = {
  planId?: string;
  recordkeeper: 'voya' | 'empower' | 'transamerica' | 'fidelity';
};

export const RECORDKEEPING_PRODUCT = 'recordkeeping';

export const hasRecordkeepingProduct = (products?: string[]): boolean =>
  products?.includes(RECORDKEEPING_PRODUCT) ?? false;
